@if (rule) {
  <div class="cell small-12">
    <label>
      <span class="label-text">{{type}} Expression:</span><a class="float-right">Expression Help</a>
      <textarea id="txarLogicExpression" style="resize: none; height: 100px;" [(ngModel)]="rule.expression" (ngModelChange)="invalidateExpression($event)" [placeholder]="placeholder"></textarea>
    </label>
  </div>
}
<div class="cell small-12">
  <button class="button hollow" (click)="testExpression()">Test Expression</button>
  <span id="evaluation" class="float-right" [ngClass]="{'compile-alert': compileSuccessful === false, 'compile-success': compileSuccessful === true}">{{validationMessage}}</span>
</div>